<template>
  <v-card :loading="loading" class="ma-3">
    <v-card-title>
      <h1 class="mr-2 subheading grey--text">{{ title }}</h1>
      <v-chip text-color="white" :color="getColor(contact.Status)">
        <v-icon v-if="contact.Status==1" small left>mdi-star-circle</v-icon>
        <v-icon v-if="contact.Status==-2" small left>mdi-cash</v-icon>
        <v-icon v-if="contact.Status==-3" small left>mdi-cash-clock</v-icon>
        <v-icon v-if="contact.Status==-4" small left>mdi-cancel</v-icon>
        {{ getDescription(contact.Status) }}
      </v-chip>
      <v-spacer/>
       <v-btn icon @click="accountPage"><v-icon>mdi-information</v-icon></v-btn>
      <v-btn icon @click="$router.go(-1)"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-container flex>
        <v-row>
          <v-col cols=2 sm=2 md=2>
            <v-text-field
              v-model="contact.Id"
              prepend-inner-icon="mdi-account"
              label="contact"
              readonly
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols=12 md=8 sm=8 xs=12>
            <v-textarea
              readonly
              auto-grow
              rows="1"
              :row-height="($vuetify.breakpoint.xs) ? 15 : 10"
              color="black-text"
              v-model="contact.Name"
              label="Όνομα πελάτη"
            >
          </v-textarea>
          </v-col>
           <v-col cols=4 sm=2 md=2 xs=4>
            <v-text-field
              :value="contact.Balance.toFixed(2)"
              label="Υπόλοιπο"
              reverse
              readonly
              prefix="€"
            ></v-text-field>
          </v-col>
          <v-col cols=12 md=6 sm=8 xs=12>
            <v-text-field
              v-model="contact.Address"
              label="Διεύθυνση"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols=6 sm=4 md=2>
            <v-text-field
              v-model="contact.City"
              label="Πόλη"
              readonly
            ></v-text-field>
          </v-col>
           <v-col v-if="contact.Telephone" cols=6 sm=4 md=2>
            <!-- If telephone contains semicolon, split and display each number separately -->
            <template v-if="contact.Telephone.includes(';')">
            <v-select
            :items="contact.Telephone.split(';').map(phone => phone.trim()).filter(phone => phone)"
            label="Τηλέφωνο"
            :value="contact.Telephone.split(';')[0].trim()"
          ></v-select>
            </template>
            <!-- If no semicolon, display as before -->
            <template v-else>
              <v-text-field
                v-model="contact.Telephone"
                label="Τηλέφωνο"
                readonly
              ></v-text-field>
            </template>
          </v-col>
            <v-col v-if="contact.Email" cols=6 sm=4 md=2>
            <!-- If email contains semicolon, show as dropdown -->
            <v-select
              v-if="contact.Email.includes(';')"
              :items="contact.Email.split(';').map(email => email.trim()).filter(email => email)"
              label="E-mail"
              :value="contact.Email.split(';')[0].trim()"
            ></v-select>
            <!-- Otherwise show as text field -->
            <v-text-field
              v-else
              v-model="contact.Email"
              label="E-mail"
              readonly
            ></v-text-field>
          </v-col>
          <v-col v-if="!nonBill" cols=6 sm=4 md=2>
            <v-text-field
              label="ΑΦΜ"
              readonly
              :value="afm(contact.Afm)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="2">
            <v-text-field
              v-model="contact.DoyDescr"
              label="ΔΟΥ"
              readonly
            ></v-text-field>
          </v-col>
          </v-row>
          <balance-row
           :transactions="transactions"
           :charge="balance.charges"
           :debit="balance.debits"
           :balance="contact.Balance"/>

      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-tabs left>
        <slot name="tabsleft"> </slot>
      </v-tabs>

      <v-tabs right>
        <slot name="tabsright"> </slot>
      </v-tabs>
    </v-card-actions>
  </v-card>
</template>

<script>
// import sumBy from "lodash/sumBy";
import BalanceRow from "./BalanceRow.vue";

export default {
    components: {
     BalanceRow,
  },
  props: {
    title: { required: true, type: String },
    api: { required: true },
    cid: { required: true, type: Number },
    nonBill: { default: false },
  },
  watch: {
    cid() {
      this.fetchCustomerInfo();
    },
  },
  data() {
    return {
      loading: true,
      balance: { charges: 0.0, debits: 0.0 },
      debits: [],
      invoices: [],
      transactions: 0,
      contact: {
        Name: "",
        Address: "",
        Telephone: "",
        Doy: "",
        City: "",
        Balance: 0,
      },
    };
  },
  async created() {
    if (this.cid) {
    await this.fetchCustomerInfo();
    }
  },

  methods: {
    accountPage() {
        let path = "customer-info"
        let params = {id: this.cid}
        if (this.api == "customers/") {
              if (this.nonBill) {
                  path = 'book-info';
              }
        } else {
              this.path = "distributor-info";
        }

        this.$router.push({"name": path, "params": params});
    },
    afm(afmnum) {
      return new String(Number(afmnum).toFixed()).padStart(9, "0");
    },
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value.toFixed(2));
    },
    /**
     * Returns a color code based on the customer grade.
     * @param {number} grade - Grade from -4 (blacklist) to 1 (good)
     * @returns {string} - Color code
    */
    getDescription(grade) {
      switch (grade) {
        case 1:
          return "Καλός"; // Green (good)
        case 0:
          return "Ουδέτερος"; // Grey (neutral)
        case -1:
          return "Ενοχλητικός/Τσίπης"; // Orange (annoying)
        case -2:
          return "Δύσκολος (Μόνο μετρητοίς)"; // Amber (should pay in cash)
        case -3:
          return "Κόκκινος (Μόνο προκαταβολή)"; // Red (should prepay)
        case -4:
          return "Μαύρη Λίστα"; // Black (blacklist)
        default:
          return "Κανονικός"; // Default to grey if out of range
      }
    },
    /**
     * Returns a color code based on the customer grade.
     * @param {number} grade - Grade from -4 (blacklist) to 1 (good)
     * @returns {string} - Color code
    */
    getColor(grade) {
      switch (grade) {
        case 1:
          return "green"; // Green (good)
        case 0:
          return "primary"; // Grey (neutral)
        case -1:
          return "#FBC02D"; // Orange (annoying)
        case -2:
          return "amber"; // Amber (should pay in cash)
        case -3:
          return "red"; // Red (should prepay)
        case -4:
          return "black"; // Black (blacklist)
        default:
          return "#607D8B"; // Default to grey if out of range
      }
    },
    async fetchCustomerInfo() {
      try {

        const response = await this.$api.get(this.api + this.cid,
        {params: {'non-billing': this.nonBill}});
        // console.log(this.$route.params.id);
        this.$store.cid = this.cid;
        this.contact = response.data;
        this.balance = response.data.Balance;
        this.loading = false;
        if (this.api == "customers/") {
          // this.debits = this.contact.Debits;
          this.$store.customer = this.contact;
        } else {
          // this.debits = this.contact.Credits;
          this.$store.supplier = this.contact;
        }
        if (this.nonBill) {
            // this.invoices = this.contact.Repairs;
            // let cost = this.contact.billing_afm != null ? sumBy(this.invoices, "RepairCost")*1.24 : sumBy(this.invoices, "RepairCost") ;
            // this.balance = {charges: cost, debits: sumBy(this.debits, "TotalValue")};
        } else {
            // this.invoices = this.contact.Invoices;
            // this.balance = {charges: sumBy(this.invoices, "TotalValue"), debits: sumBy(this.debits, "TotalValue")};
        }
        this.transactions = this.invoices.length + this.debits.length;

      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
